<template>
  <div>
    <b-modal
      :id="'askModal_' + id"
      :title="title"
      @ok="handleOk"
      @close="handleClose"
      @cancel="handleCancel"
      no-close-on-backdrop
    >
      <div v-html="message"></div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["title", "message"],
  data() {
    return {
      id: Math.floor(Math.random() * 1000),
    };
  },
  mounted() {},
  methods: {
    handleOk() {
      this.$emit("ok");
    },
    handleClose() {
      this.$emit("close");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    ask() {
      var self = this;

      this.$bvModal.show("askModal_" + self.id);
    },
  },
};
</script>

<style></style>
